// extracted by mini-css-extract-plugin
export default {"contents":"zE-z","sectionHeading":"AE-z"};